'use client'
import React, { useRef, useState } from 'react';
import AgentDisplayCard from '@components/AgentDisplayCard';
// import ProjectCardNew from '@components/PropertyCardNew';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules'
import 'swiper/css';
import 'swiper/css/navigation';
import Link from 'next/link';


const AgentCardSlider = ({ title, items, dictionary, lang, pl = 3 }) => {
    return (
        <section className={`pl-3 mt-3 w-full pb-3 mx-auto border-b-[1px] border-b-forth`}>
            {title && (
                <h2 className='text-maincolor font-bold text-xl mb-2'>{title}</h2>

            )}
            <div className='sm:block hidden'>
                <Swiper
                    slidesPerView={4}
                    // spaceBetween={8}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    className=''
                >
                    {items.map((item, index) => (
                        <SwiperSlide key={index} className=' '>
                            <div>
                                <AgentDisplayCard agent={item} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {items && (
                <div className='sm:hidden block'>
                    <Swiper
                        spaceBetween={10}
                        slidesPerView={1.5}
                    >
                        {items.map((item, index) => (
                            <SwiperSlide key={index}>
                                <AgentDisplayCard agent={item} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
        </section>
    );
};

export default AgentCardSlider;